__turbopack_context__.v({
  "dividedGrid": "DashboardPanel-module-scss-module__6oxwnW__dividedGrid",
  "dividedList": "DashboardPanel-module-scss-module__6oxwnW__dividedList",
  "item": "DashboardPanel-module-scss-module__6oxwnW__item",
  "live": "DashboardPanel-module-scss-module__6oxwnW__live",
  "panel": "DashboardPanel-module-scss-module__6oxwnW__panel",
  "panelBody": "DashboardPanel-module-scss-module__6oxwnW__panelBody",
  "panelHeader": "DashboardPanel-module-scss-module__6oxwnW__panelHeader",
});
